import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTheme } from '../hooks/useTheme';
import { Spacing, FontSize, FontWeight } from '../theme/tokens';

export interface HeroBannerProps {
  title?: string;
  subtitle?: string;
}

export const HeroBanner: React.FC<HeroBannerProps> = ({
  title = 'Share big files.\nDirect & Unlimited.',
  subtitle = 'Instant peer-to-peer file streaming over WebTorrent & WebRTC. No upload size caps, no cloud storage logs.',
}) => {
  const { colors } = useTheme();

  return (
    <View style={styles.heroHeader}>
      <Text style={[styles.heroTitle, { color: colors.text }]}>{title}</Text>
      <Text style={[styles.heroSubtitle, { color: colors.subtext }]}>{subtitle}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  heroHeader: {
    marginBottom: Spacing.xl,
  },
  heroTitle: {
    fontSize: FontSize.hero,
    fontWeight: FontWeight.black,
    letterSpacing: -3,
    lineHeight: FontSize.hero * 1.05,
    marginBottom: Spacing.md,
  },
  heroSubtitle: {
    fontSize: FontSize.lg,
    lineHeight: FontSize.lg * 1.5,
  },
});
